module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_5000_Active@1x-6f735b5e6cbb209ab984836f3bdb1d0a.png";